export const LOGIN_STATES = {
  DEFAULT: 'default',
  INVALID_CREDENTIALS: 'invalid_credentials',
  ACCOUNT_BLOCKED: 'account_blocked',
  ACCOUNT_DISABLED: 'account_disabled',
  NOT_ACTIVATED: 'not_activated',
} as const;

export type LoginState = (typeof LOGIN_STATES)[keyof typeof LOGIN_STATES];
